import { Divider, Flex, Typography } from "antd"

import Icon from "../../../../../Icon"
import { formatCurrency } from "../../../../../Utils/utils"

import "./CommissionPerAlertBlock.less"

const { Text } = Typography

const CommissionPerAlertBlock = ({ ethoca, verifi }) => {
  return (
    <Flex className="commission-per-alert-block" gap={16} align="center">
      <Flex gap={8} align="center">
        <Icon className="info-icon" type="info_bubble" />
        <Text type="secondary" strong>
          Commission per alert
        </Text>
      </Flex>
      <Flex align="center">
        <Flex gap={8} align="center">
          <Text type="secondary" strong className="provider-name">
            Ethoca
          </Text>
          <Text strong>{formatCurrency(ethoca / 100, true)}</Text>
        </Flex>
        <Divider className="vertical-divider" type="vertical" />
        <Flex gap={8} align="center">
          <Text type="secondary" className="provider-name" strong>
            Verifi
          </Text>
          <Text strong>{formatCurrency(verifi / 100, true)}</Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default CommissionPerAlertBlock
